import { TYPES_CONFIG } from '../constants';
export var isComponentChange = function isComponentChange(propertyType, currentOperator, updatedOperator) {
  var operatorsSettings = TYPES_CONFIG[propertyType];
  return operatorsSettings[currentOperator].component !== operatorsSettings[updatedOperator].component;
};